import React from "react";
import Layout from "../../commons/Layout";
import PageTopDescription from "../../commons/PageTopDescription";
import QuestionAndAnswer from "../../commons/QuestionAndAnswer";
import { useQuery } from "@tanstack/react-query";
import { getPolicies } from "../../services/policies-service";
import QuestionAndAnswerLoaders from "../../commons/loaders/QuestionAndAnswerLoaders";

function PrivacyPolicy() {
  let policies_data = [];

  // Queries
  const policies = useQuery({
    queryKey: ["policies"],
    queryFn: async () => {
      const result = await getPolicies();
      if (result.data.error) {
      }
      return result;
    },
    onError: (error) => {
      console.log("error when fetching policies", error);
    },
  });

  policies_data = policies?.data?.data?.data;

  return (
    <Layout>
      <div className="w-[70%] max-lg:w-4/5 max-md:w-[90%] mx-auto py-24 max-md:py-12">
        <PageTopDescription
          heading={"Privacy Policy"}
          subHeading="Our Privacy Policy"
          description="Please read our privacy policy carefully to understand how collect and use your data."
        />
        <div className="mt-10 max-md:mt-5"></div>
        {policies.isLoading && <QuestionAndAnswerLoaders />}

        {policies_data?.map((faq, index) => {
          return (
            <QuestionAndAnswer
              number={index + 1}
              question={faq.title}
              answer={faq.answer}
            />
          );
        })}
      </div>
    </Layout>
  );
}

export default PrivacyPolicy;
